// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604160804/js/" + chunkId + "." + {"44":"6423181f","225":"9aec0017","481":"b80f5cd6","486":"aeb733ac","770":"d3b89b31"}[chunkId] + ".0.9388483727418815.chunk.js";
};